import { Emitter } from '@dreamtree-org/twreact-ui';

/** Single shared instance — twreact-ui's Navbar requires one (internal event bus). */
export default new Emitter();
